<template>
    <div class="wrapper">

        <router-view></router-view>

        <!-- HeaderNav section -->
        <HeaderNav></HeaderNav>

        <!-- Breadcrumb section -->
        <BreadcrumbSection breadcrumbDetail="Unlock innovation for every business with the power of Riset.ai" breadcrumbName="privacy_policy" breadcrumbTitle="Privacy Policy"></BreadcrumbSection>

        <!-- Banner section -->
        <BannerTwo></BannerTwo>

        <!-- Footer section -->
        <FooterSection></FooterSection>

    </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue'
import BannerTwo from '@/components/BannerTwo.vue'
import FooterSection from '@/components/FooterSection.vue'
import BreadcrumbSection from '@/components/BreadcrumbSection.vue'

export default {
    components: {
        HeaderNav,
        BannerTwo,
        FooterSection,
        BreadcrumbSection,
    }
}
</script>
